import { Root } from '@radix-ui/react-radio-group'
import { cn } from '@seen/ui'
import type { ComponentPropsWithoutRef, ForwardedRef, JSX } from 'react'
import { forwardRef } from '#src/utils/forwardRef.ts'

export interface RadioGroupProps<TValue extends string = string> extends Omit<
  ComponentPropsWithoutRef<typeof Root>,
  'onChange' | 'onValueChange'
> {
  asChild?: boolean
  defaultValue?: TValue
  value?: TValue
  onChange?: (value: TValue) => void
  disabled?: boolean
  name?: string
  required?: boolean
  orientation?: 'horizontal' | 'vertical'
  dir?: 'ltr' | 'rtl'
  loop?: boolean
  /**
   * [data-disabled] - Present when disabled
   */
  className?: string
}

export const RadioGroup = forwardRef(RadioGroupWithRef)

function RadioGroupWithRef<TValue extends string>(
  { className, onChange, ...delegated }: RadioGroupProps<TValue>,
  ref: ForwardedRef<HTMLDivElement>
): JSX.Element {
  return (
    <Root
      className={cn('grid', className)}
      onValueChange={onChange}
      {...delegated}
      ref={ref}
    />
  )
}
